import { get } from './client.js';

/**
 * sidecar /admin/warnings — 系統警示聚合（pull mode，每 30s poll）
 *
 * server.js proxy `/sidecar/*` → sidecar :8081（自動注入 RELAY_SHARED_SECRET）
 * 回傳的 tenants[] 是全 tenant；UI 端依 useTenant().tenants 過濾出 user 有權限看的。
 */
export const warningsApi = {
    fetch: () => get('/sidecar/admin/warnings'),
};
